import i18n from "i18next";
import { useEffect, useState } from "react";
import { initReactI18next } from "react-i18next";
export const useI18next = (options) => {
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(null);
    useEffect(() => {
        /* eslint-disable import/no-named-as-default-member */
        i18n.use(initReactI18next).init(options, (error) => {
            if (error) {
                setError(error);
            }
            else {
                setLoaded(true);
            }
        });
    }, [options]);
    return [loaded, error];
};
//# sourceMappingURL=useI18next.js.map